// @flow
import produce from 'immer';
import _ from 'lodash';

import { GET_SETTINGS, UPDATE_SETTINGS } from 'admin/constants/actions';

const initialState: Settings = {
	data: {
		items: {
			minVotes: 0,
		},
	},
	isBusy: false,
};

export default function settingsReducer(state: Settings = initialState, { type, payload }: Action) {
	return produce(state, (draft): Settings => {
		switch (type) {
			case GET_SETTINGS.START:
			case UPDATE_SETTINGS.START:
				return _.set(draft, 'isBusy', true);

			case GET_SETTINGS.SUCCESS:
				_.set(draft, 'data', { ...draft.data, ..._.get(payload, 'data') });
				_.set(draft, 'isBusy', false);

				return draft;

			case UPDATE_SETTINGS.SUCCESS:
				_.set(draft, 'data', payload);
				_.set(draft, 'isBusy', false);

				return draft;

			case UPDATE_SETTINGS.FAIL:
			case GET_SETTINGS.FAIL:
				return _.set(draft, 'isBusy', false);

			default:
				return state;
		}
	});
}
